import type {RepresentativeList} from "../../../types/representatives.types";

import {deleteRepresentative} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";

import {representativeKeys, representativeMutationKeys} from "../../../representative-keys";

export function deleteRepresentativeMutationOptions() {
  const listFilter = {queryKey: representativeKeys.lists()};

  return mutationOptions({
    mutationFn: (id: string) => deleteRepresentative(id),
    mutationKey: representativeMutationKeys.deleteRepresentative,
    onMutate: async (deletedId, {client}) => {
      await client.cancelQueries(listFilter);
      const previousLists = client.getQueriesData<RepresentativeList>(listFilter);

      for (const [key, list] of previousLists) {
        const params = key[2];

        if (
          !list ||
          typeof params !== "object" ||
          params === null ||
          !("state" in params) ||
          params.state !== "ACTIVE" ||
          !list.items.some((item) => item.representativeId === deletedId)
        ) {
          continue;
        }

        client.setQueryData<RepresentativeList>(key, {
          ...list,
          items: list.items.filter((item) => item.representativeId !== deletedId),
          meta: {...list.meta, total: Math.max(0, list.meta.total - 1)},
        });
      }

      return {previousLists};
    },
    onError: (_error, _deletedId, context, {client}) => {
      for (const [key, snapshot] of context?.previousLists ?? []) {
        client.setQueryData(key, snapshot);
      }
    },
    onSuccess: async (_result, deletedId, _context, {client}) => {
      client.removeQueries({queryKey: representativeKeys.detail(deletedId)});
      await client.invalidateQueries(listFilter);
    },
  });
}
